/**
 * Reusable sequential pulsing dots indicator
 * Used across loading, uploading, and processing states
 */

import { motion } from 'framer-motion';

interface PulsingDotsProps {
  count?: number;
  size?: number;
  color?: string;
  className?: string;
}

export const PulsingDots = ({
  count = 3,
  size = 4,
  color = 'bg-purple-500 dark:bg-purple-400',
  className = '',
}: PulsingDotsProps) => {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <motion.div
          key={i}
          className={`rounded-full ${color}`}
          style={{ width: size, height: size }}
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.4, 1, 0.4],
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            delay: i * 0.15,
            ease: 'easeInOut',
          }}
        />
      ))}
    </div>
  );
};
